import { useEffect, useState } from 'react'
import { ProductsStore } from '../../factories/database/products-store'
import { QuickKeyKey } from '../../quick-keys/qk-types'
import { useProductsStore } from '../../ng-compat/hooks'

const DEFAULT_IMAGE = 'no-image-white-thumb.png'

const isChild = (quickKey: QuickKeyKey) => {
  const attr = quickKey.node.attributes.find(attr => attr.key === 'isChild')
  if (!attr) {
    return false
  }

  return attr.value === '1'
}

const getImageURLForQuickKey = async (
  productStore: ProductsStore,
  quickKey: QuickKeyKey
) => {
  if (!quickKey.viewData.showImage) {
    return
  }

  const productID = quickKey.node.product_id
  if (!productID) {
    return
  }

  const product = await productStore.get(productID)
  if (!product) {
    return
  }

  if (isChild(quickKey) && product.skuImages?.length) {
    const isVariantParent = product.has_variants
    const isVariantChild = Boolean(product.variant_parent_id)
    if (isVariantChild || isVariantParent) {
      return product.skuImages[0].sizes.sm
    }
  }

  if (product.images?.length) {
    return product.images[0].sizes.sm
  }

  if (
    product.image_thumbnail_url &&
    !product.image_thumbnail_url.includes(DEFAULT_IMAGE)
  ) {
    return product.image_thumbnail_url
  }
}

export const useImageURLForQuickKey = (quickKey: QuickKeyKey) => {
  const productsStore = useProductsStore()
  const [imageURL, setImageURL] = useState<string | null>(null)

  useEffect(() => {
    const fetchImageURL = async () => {
      const url = await getImageURLForQuickKey(productsStore, quickKey)
      setImageURL(url || null)
    }

    fetchImageURL()
  }, [productsStore, quickKey])

  return imageURL
}
